import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CustomerServiceService } from "src/app/customer/customer-service.service";

@Component({
  selector: "app-model",
  templateUrl: "./model.component.html",
  styleUrls: ["./model.component.css"],
})
export class ModelComponent implements OnInit {
  token: any;
  user_Info: any;

  constructor(
    private matdialogref: MatDialogRef<ModelComponent>,
    private router: Router,
    private service: CustomerServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    this.service.GetProfile(this.token).subscribe((response: any) => {
      this.user_Info = response.body.data;
    });
  }
  close() {
    this.matdialogref.close();
  }
  navigateToTrips() {
    this.router.navigateByUrl("/trips");
    localStorage.setItem("quotes", "quotes");
    this.matdialogref.close();
    this.service
      .findExactTruck(this.data, this.token)
      .subscribe((response: any) => {
        if (response.status == 201) {
          localStorage.removeItem("quotes");
        }
      });
  }
}
